module.exports = __webpack_public_path__ + "img/service-10.bd912e9f.jpg";